import { withRouter, RouteComponentProps } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { BlueButton } from '@share/components';
import { Routes } from '@share/constants';

import { ILoginState, IMenuState } from '@share/store/slices';
import { connect } from 'react-redux';
import { RootState } from '@share/utils';

import TutorialVideosImg from '@assets/images/member-videos.jpg';
import Chevrons from '@assets/icons/chevrons.png';

import './style.scss';

interface IMapStateToProps {
  loginStore: ILoginState;
  menuStore: IMenuState;
}

interface IProps extends RouteComponentProps, IMapStateToProps {}

function TutorialVideosComponent(props: IProps) {

  const { loginStore, menuStore } = props;
  const { account } = loginStore;
  const { items, loading } = menuStore;

  if (items?.isRemoveMemberVideos || loading) {
    return null;
  }

  const goToVideos = () => {
    props.history.push(`/${account?.name}${Routes.MemberVideos}`);
  };

  return (
    <div className="tutorial-videos-rsi-upgrade" style={{ backgroundImage: `url(${TutorialVideosImg})` }}>
      <div className="tutorial-videos-rsi-upgrade__wrapper">
        <div className="tutorial-videos-rsi-upgrade__info-wrapper">
          <p className="tutorial-videos-rsi-upgrade__title">
            <FormattedMessage id="member.tutorial.videos" />
          </p>
          <p className="tutorial-videos-rsi-upgrade__description">
            <FormattedMessage id="get.the.most.out.of.your.membership" />
          </p>
          <div className="tutorial-videos-rsi-upgrade__btn-wrapper">
            <BlueButton onClick={goToVideos}>
              <FormattedMessage id="watch.videos" />
              <div style={{ backgroundImage: `url(${Chevrons})` }} className="image-chevrons" />
            </BlueButton>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    loginStore: state.loginStore,
    menuStore: state.navigationMenuStore,
  };
};

const TutorialVideosWithRouter = withRouter(TutorialVideosComponent);

export const TutorialVideos = connect(mapStateToProps)(TutorialVideosWithRouter);
